import React from 'react';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';
import GetMedicalRecord from './GetMedicalRecord';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);

export default class GetUser extends React.Component {
  state = {
    user: []
  }

  componentDidMount() {
    //api.get(`/user/${this.props.user_id}`, { headers: { 'x-access-token': token } })
    apiProfessional.getUser(this.props.user_id)
      .then(res => {
        const user = res.data;
        this.setState({ user });
      })
  }

  render() {
    return (
      <ul>
        {this.state.user.map(details =>
          <>
            <p id="RI-Title-Cadastro-Paciente" >Nome do Paciente: </p><p>{details.name}</p>
            {details.user_type === "Paciente" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Paciente da instituição</p></> :
              details.user_type === "Funcionario" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Funcionário da instituição</p></> :
                null}
            <p id="RI-Title-Cadastro-Paciente" >Data de Nascimento: </p><p>{details.birth}</p>
            <p id="RI-Title-Cadastro-Paciente" >CPF: </p><p>{details.cpf}</p>
            <p id="RI-Title-Cadastro-Paciente" >Gênero: </p><p>{details.gender}</p>
            <p id="RI-Title-Cadastro-Paciente" >Endereço: </p><p>{details.adress}</p>

            <hr id="line-dashed-separator"></hr>
            <h3 id="specific-tittle-small">Prontuário Inicial do Paciente</h3>
            <GetMedicalRecord user_id={details._id} />
            <hr id="line-dashed-separator"></hr>
            <br></br>
          </>)}
      </ul>
    )
  }
}